module.exports = __webpack_public_path__ + "img/UTESCA-1.85524fbf.jpg";